;(function () {
  'use strict';

  /**
   * プレビューリスト作成
   * @param   {object}  files
   * @returns {string}  previews
   */
  function buildDocumentPreviews(files, itemId) {
    var previews = '';
    $.each(files, function (index, file) {
      if (file.error) {
        toastr.error(file.error);
        return true;  // continue
      } else {
        previews += buildDocumentPreview(file, itemId);
      }
    });

    return previews;
  }

  /**
   * プレビュー作成
   * @param   {object}  file
   * @returns {string}  previewItem
   */
  function buildDocumentPreview(file, itemId) {
    var deleteButton = '<p class="document-preview__delete" style="display: inline;"><a><i class="fa fa-times" aria-hidden="true"></i></a></p>';
    var documentPreview = '<a href="' + file.url + '" class="document-preview__file">' + file.original_name + ' ' + deleteButton + '</a>';
    var fileForm = '<input type="hidden" name="report_item[document][' + itemId + '][]" value="' + file.name + '">';
    var previewItem = '<li class="document-preview__item">' + documentPreview + fileForm + '</li>';

    return previewItem;
  }

  /**
   * プログレスバー 表示
   */
  function showProgress(progress) {
    progress.removeClass('hidden');
  }

  /**
   * プログレスバー 非表示
   */
  function hideProgress(progress) {
    progress.addClass('hidden');
  }

  $(function () {
    // 画像ドラッグ・アンド・ドロップのブラウザデフォルト動作停止
    $(document).on('drop dragover', function (e) {
      e.preventDefault();
    });

    //一度にアップロードできる文書ファイル数の制限
    var maxDocumentFiles = 10

    // ファイル選択からアップロードした時
    $('#report-item-document-file').change(function (){
      var documentForm = document.getElementById('report-item-document-file');
      if(documentForm.files.length > maxDocumentFiles){
        documentForm.value = ""
        window.toastr.error("アップロードするファイルは、" + maxDocumentFiles +  "個以下にしてください。", { timeOut: 4000 }, { preventDuplicates: true });
      }
    });

    // ドラッグ＆ドロップでアップロードした時
    $('#report-item-document-fileupload-label').on('drop', function(e) {
      var documentForm = e.originalEvent.dataTransfer;
      if(documentForm.files.length > maxDocumentFiles){
        e.stopPropagation();
        e.preventDefault();
        window.toastr.error("アップロードするファイルは、" + maxDocumentFiles +  "個以下にしてください。", { timeOut: 4000 }, { preventDuplicates: true });
      }
    });

    var $form = $('form[data-report-post-form]');

    // ファイルアップロード
    $form.find('input[type="file"].upload__report-item-document').each(function () {
      var $uploadForm = $(this).closest('.report-item-document-fileupload');
      var $label = $uploadForm.find('.report-item-media-fileupload-label');
      var $preview = $uploadForm.find('.document-preview');

      $(this).fileupload({
        dropZone: $uploadForm,
        pasteZone: $uploadForm,
        url: '/temporary_documents?resource_name=report_item_document',
        dataType: 'json',
        method: 'POST',
        formData: {},
        messages: {
          maxFileSize: '30MBを超えています。'
        },
        processQueue: [
          {
            action: 'validate',
            always: true,
            maxFileSize: 1024 * 1024 * 30,  // 30MB
          }
        ],

        /**
         * アップロード開始イベントハンドラ
         * @param {event}   e
         * @param {object}  data
         */
        start: function (e, date) {
          var $progress = $preview.find('.document-preview__progress');
          showProgress($progress);
        },

        /**
         * アップロード中イベントハンドラ
         * @param {event}   e
         * @param {object}  data
         */
        progressall: function (e, data) {
          var $progressBar = $preview.find('.document-preview__progress-bar');
          $progressBar.css('width', parseInt(data.loaded / data.total * 100, 10) + '%');
        },

        /**
         * ファイル毎のアップロード完了イベントハンドラ
         * @param {event}   e
         * @param {object}  data
         */
        done: function (e, data) {
          // プレビュー表示
          var itemId = $(this).data('item-id');
          var previews = buildDocumentPreviews(data.result.files, itemId);
          if (previews) {
            var $previewList = $preview.find('.document-preview__list');
            if ($previewList.length > 0) {
              $previewList.append($(previews));
            } else {
              $preview.append($('<ul class="document-preview__list">' + previews + '</ul>'));
            }
          }
        },

        /**
         * アップロード完了イベントハンドラ
         * @param {event}   e
         * @param {object}  data
         */
        stop: function (e, date) {
          var $progress = $preview.find('.document-preview__progress');
          hideProgress($progress);
        }
      }).on('fileuploadprocessalways', function (e, data) {
        if(data.files.error) {
          window.toastr.error(data.files[0].name + "は" + data.files[0].error, { timeOut: 4000 }, { preventDuplicates: true });
        } else {
          data.submit()
        }
      });
    });

    // アップロードキャンセル（画像削除）
    $form.on('click', '.document-preview__delete', function () {
      var $previewItem = $(this).closest('.document-preview__item');
      $previewItem.remove();
    });
  });
}.call(this));
